(() => {
  function start(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const list = root.querySelector('.bi-product-list');
    const controls = root.querySelector('.bi-carousel-controls');
    const previous = controls.querySelector('[data-direction="previous"]');
    const next = controls.querySelector('[data-direction="next"]');
    const counter = controls.querySelector('.bi-counter');
    const stride = () => list.children[1].offsetLeft - list.children[0].offsetLeft;
    const limit = () => Math.max(0, list.scrollWidth - list.clientWidth);
    const update = () => {
      const step = stride(), total = Math.ceil(limit() / step) + 1;
      const current = Math.min(total, Math.round(list.scrollLeft / step) + 1);
      previous.disabled = list.scrollLeft <= 1;
      next.disabled = list.scrollLeft >= limit() - 1;
      counter.textContent = current + '/' + total;
    };
    const move = direction => list.scrollTo({left: Math.max(0, Math.min(limit(), list.scrollLeft + direction * stride())), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    list.addEventListener('scroll', update, {passive:true});
    list.addEventListener('keydown', event => {
      if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();
      if (event.key === 'Home' || event.key === 'End') list.scrollTo({left:event.key === 'Home' ? 0 : limit(), behavior:'instant'});
      else move(event.key === 'ArrowLeft' ? -1 : 1);
    });
    controls.hidden = false;
    new ResizeObserver(update).observe(list);
    update();
  }
  document.querySelectorAll('[data-ingredients-carousel]').forEach(start);
})();
